// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-8beee6d8] .el-drawer__body {\n  padding: 0 20px;\n}\n.config_title[data-v-8beee6d8] {\n  margin-bottom: 10px;\n  width: 182px;\n  text-align: right;\n}\n.config_describe[data-v-8beee6d8] {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n.item_unit[data-v-8beee6d8] {\n  margin-left: 10px;\n}\n.el-form-item.is-required .config_describe[data-v-8beee6d8]:before {\n  content: \"*\";\n  color: #ff4949;\n  margin-right: 0;\n  display: inline;\n}", ""]);
// Exports
module.exports = exports;
